import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/shared/lib/supabase";
import { useAppContext } from "./useAppContext";

export function useIsAdmin() {
  const { user, isLoading: userLoading } = useAppContext();
  const { data: isAdmin = false, isLoading: adminCheckLoading } = useQuery({
    queryKey: ["is-admin", user?.user_id],
    queryFn: async () => {
      if (!user?.user_id) {
        return false;
      }

      const { data, error } = await supabase
        .from("admins")
        .select("id")
        .eq("user_id", user.user_id)
        .maybeSingle();

      if (error) {
        console.error("Error checking admin status:", error);
        return false;
      }

      return !!data;
    },
    enabled: !!user?.user_id,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  return {
    isAdmin,
    isLoading: userLoading || adminCheckLoading,
  };
}
